<div vng-dialog-title class="text-center">Add To FlyCuts</div>
<form class="clearfix form" [formGroup]="form" (ngSubmit)="form.valid && addToShortcut(form.value)">
  <div>You are about to add FlyShare to FlyCuts. Pick a category to add.</div>
  <div style="display: flex; flex-direction: column" class="top-gap">
    <!-- Shared app-category-select (same recipe as add-shortcut; no label here);
         creation stays here via shortcutCategoryRename. -->
    <app-category-select
      #selectElem
      style="width: 100%"
      class="w-100"
      [control]="form.controls['category_id']"
      [options]="categoryOptions"
      [error]="
        form.controls['category_id'].invalid &&
        (form.controls['category_id'].dirty || form.controls['category_id'].touched) &&
        form.controls['category_id'].hasError('required')
          ? 'You must select a category.'
          : ''
      "
      (createCategory)="shortcutCategoryRename($event ? { name: $event } : {})"
    ></app-category-select>
  </div>

  <div class="dialog-actions">
    <button style="flex: 1" type="button" vng-button variant="outline" tabindex="2" (click)="close()">Cancel</button>
    <button style="flex: 1" vng-button variant="primary" tabindex="-1">Save</button>
  </div>
</form>
